import { useScrollRestoration } from '@/hooks/useScrollRestoration';

/**
 * ScrollRestoration Component
 * Automatically saves and restores scroll positions when navigating
 * Place this component at the root of your app (inside Router)
 */
function ScrollRestoration() {
    useScrollRestoration();
    return null;
}

export default ScrollRestoration;
